var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDirectorCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 51c13.806 0 25-11.194 25-25S39.806 1 26 1 1 12.194 1 26s11.194 25 25 25z",
    stroke: "#E3E4EA",
    fill: "#E1DDFD"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 39.979 10.368)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.562
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#AC9EE4",
    cx: 14.04,
    cy: 6.899,
    r: 6.899
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.08 25.007c-3.019-4.204-8.166-6.98-14.04-6.98-5.875 0-11.022 2.776-14.04 6.98",
    stroke: "#4615D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirectorCircle);
export default __webpack_public_path__ + "static/media/icon-director-circle.38e812fe94942de39639580a96f0174d.svg";
export { ForwardRef as ReactComponent };